module.exports = __webpack_public_path__ + "static/media/happyNews.97fd742a.svg";